<!-- Recuperar contraseña: mismo diseño que /login (clases lg2-* del parcial ../_login-shell.scss).
     Marca a la izquierda con una ilustracion fija (sin slider) y el formulario a la derecha.
     Misma logica de antes: recoverPassword(email) -> toast + vuelve a /login. -->
<div class="lg2-page">

  <!-- ── Panel de marca (izquierda; en mobile es un encabezado compacto) ── -->
  <aside class="lg2-brand">
    <div class="lg2-brand-grid" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--a" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--b" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--c" aria-hidden="true"></div>

    <!-- misma marca que /login: cubo + wordmark, o el logo propio de la empresa si la URL lo trae -->
    <div class="lg2-mark">
      <ng-container *ngIf="!hasCompanyLogo">
        <img src="assets/icon.png" alt="" class="lg2-mark-cube">
        <span class="lg2-mark-word">CUBE</span>
      </ng-container>
      <span class="lg2-mark-logo" *ngIf="hasCompanyLogo"><img [src]="base64Logo" alt="Company logo"></span>
      <span class="lg2-mark-tag">{{ 'ModuleLogin.labelBrandTag' | translate }}</span>
    </div>
    <p class="lg2-mobile-tag">{{ 'ModulRecoPasswd.labelBrandTitle' | translate }}</p>

    <!-- ilustracion unica (datos de ejemplo): el correo con el enlace de restablecimiento -->
    <div class="lg2-slides">
      <section class="lg2-slide is-active">
        <div class="lg2-ill" aria-hidden="true">
          <div class="lg2-ill-halo"></div>
          <div class="lg2-ic lg2-ic--main">
            <div class="lg2-ic-hd"><i class="fas fa-envelope-open-text"></i> Password reset</div>
            <div class="rp-mail-line"><span>To</span> alex&#64;example.com</div>
            <div class="rp-mail-txt"><i></i><i></i><i></i></div>
            <div class="rp-mail-btn">Reset password</div>
            <div class="rp-mail-foot"><i class="far fa-clock"></i> Link valid for a limited time</div>
          </div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--tr"><i class="fas fa-paper-plane"></i> Link sent</div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--bl lg2-ic--ok"><i class="fas fa-shield-alt"></i> Secure link</div>
          <span class="lg2-bubble lg2-bubble--1"><i class="fas fa-key"></i></span>
          <span class="lg2-bubble lg2-bubble--2"><i class="fas fa-lock"></i></span>
          <span class="lg2-bubble lg2-bubble--3"><i class="fas fa-at"></i></span>
        </div>
        <h2 class="lg2-slide-title">{{ 'ModulRecoPasswd.labelBrandTitle' | translate }}</h2>
        <p class="lg2-slide-txt">{{ 'ModulRecoPasswd.labelBrandTxt' | translate }}</p>
      </section>
    </div>
    <!-- ocupa el lugar de los puntos del slider para que la ilustracion quede centrada -->
    <div></div>
  </aside>

  <!-- ── Formulario (derecha) ── -->
  <main class="lg2-form-wrap">
    <div class="lg2-card">

      <span class="lg2-key" aria-hidden="true"><i class="fas fa-key"></i></span>
      <h2 class="lg2-title">{{ 'ModulRecoPasswd.labelForgotTitle' | translate }}</h2>
      <p class="lg2-subtitle">{{ 'ModulRecoPasswd.labelForgotSub' | translate }}</p>

      <form [formGroup]="cardForm" class="lg2-form" (ngSubmit)="!isLoading && resetPass()" novalidate>

        <div class="lg2-field">
          <label for="email">{{ 'ModulRecoPasswd.labelEmail' | translate }}</label>
          <div class="lg2-input"
            [class.is-invalid]="submitted && cardForm.controls.email.invalid"
            [class.is-valid]="cardForm.controls.email.valid">
            <span class="lg2-input-icon"><i class="fas fa-envelope"></i></span>
            <input type="email" id="email" formControlName="email" autocomplete="email"
              maxlength="254" required autofocus
              [attr.aria-invalid]="submitted && cardForm.controls.email.invalid"
              aria-describedby="err-email"
              placeholder="name@company.com">
          </div>
          <div class="lg2-err" id="err-email" *ngIf="submitted && cardForm.controls.email.invalid">
            <i class="fas fa-exclamation-circle"></i>
            <span *ngIf="cardForm.controls.email.errors?.required">{{ 'ModuleLogin.msgvalidReqUser' | translate }}</span>
            <span *ngIf="cardForm.controls.email.errors?.email">{{ 'ModuleLogin.msgvalidEmail' | translate }}</span>
          </div>
        </div>

        <button type="submit" class="lg2-submit" [disabled]="isLoading" [class.is-loading]="isLoading">
          <dx-load-indicator *ngIf="isLoading" [visible]="true" height="18" width="18"></dx-load-indicator>
          <span>{{ (isLoading ? 'ModulRecoPasswd.labelSending' : 'ModulRecoPasswd.btnSendLink') | translate }}</span>
          <i class="fas fa-paper-plane lg2-submit-arrow" *ngIf="!isLoading"></i>
        </button>

        <a routerLink="/login" class="lg2-back">
          <i class="fas fa-arrow-left"></i> {{ 'ModulRecoPasswd.btnBackSignin' | translate }}
        </a>
      </form>
    </div>
  </main>
</div>

<!-- Message forgot password -->
<dx-popup [showTitle]="false" [width]="500" height="auto" [maxHeight]="'90vh'" [deferRendering]="false" [dragEnabled]="false" [closeOnOutsideClick]="true" #frame id="frameModalTop">
  <div class="cs-modal-dialog modal-notify modal-success" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <p class="heading lead">{{'ModalCheckEmail.title' | translate}}</p>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="frame.instance.hide()">
          <span aria-hidden="true" class="white-text">&times;</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body">
        <div class="text-center">
          <i class="fas fa-check fa-4x mb-3 animated rotateIn"></i>
          <p>{{'ModalCheckEmail.msg' | translate}}</p>
        </div>
      </div>
      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <a type="button" class="waves-effect btn btn-green1" (click)="frame.instance.hide()">{{'ModalCheckEmail.btnNo' | translate}}</a>
        <a type="button" class="waves-effect btn btn-grey1">{{'ModalCheckEmail.btnGetNow' | translate}}
          <i class="far fa-gem ml-1"></i>
        </a>
      </div>
    </div>
    <!--/.Content-->
  </div>
</dx-popup>
